import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const QUOTE_BUBBLE_2_ACTIVITY_FRAGMENT = gql `
  fragment QuoteBubble2ActivityFragment on QuoteBubble2Activity {
    rounds {
      speakerImage {
        image {
          ...AssetFragment
        }
      }
      steps {
        answer
        id
        optionalAnswerImage: optionalImage {
          image {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default QUOTE_BUBBLE_2_ACTIVITY_FRAGMENT;
